// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3q2Il","colBig":"styles_colBig__2MJA6","colSmall":"styles_colSmall__VSIYK"};